import { registerEnglishArea } from '@/i18n/catalogue';

/**
 * I-2453: what a reorder says out loud (`messages/en/reorder.ts`) stays out of the launch entry. The
 * sidebar's pages and namespaces are drawn on the first screen, but nobody hears a move before they
 * make one: the words load with the drag kit (`loadSortableKit`), and a keyboard move made before
 * that (Alt+↑/↓ on a page) waits for them through `sayReorder`, so it is never announced as a raw
 * key. The controls' own labels are `reorderControls`, which the launch draws.
 */
let words: Promise<void> | null = null;
let loaded = false;

/** Loads the English reorder words once; a failed load is tried again by the next ask. */
export function loadReorderWords(): Promise<void> {
  words ??= import('@featit/shared/i18n/messages/en/reorder').then(
    ({ reorder }) => {
      registerEnglishArea('reorder', reorder);
      loaded = true;
    },
    (error: unknown) => {
      words = null;
      throw error;
    },
  );
  return words;
}

/** Says a reorder's words now when they are in, else as soon as they are. */
export function sayReorder(say: () => void): void {
  if (loaded) {
    say();
    return;
  }
  void loadReorderWords().then(say, () => undefined);
}
